// import React from "react";
// import { useLocation } from "react-router-dom";
// import PickRole from "./components/PickRole.tsx";
import RegisterMainPage from "./components/RegisterMainPage.tsx";

const Register = () => {
  // const location = useLocation();
  // const queryParams = new URLSearchParams(location.search);
  // const queryValue = queryParams.get("roleType");

  // if (!queryValue) {
  //   return <PickRole />;
  // }
  // if (!queryValue) {
  //   return <PickRole />;
  // }

  return (
    <>
      <RegisterMainPage />
    </>
  );
};

export default Register;
